import { FciValueTypes } from '../constants'

export const tableHeaders = ['Funding Date', 'Reference', 'Investor Account', 'Investor Name', 'Amount Funded', 'Notes']

export const tableBodyData: Record<string, FciValueTypes> = {
  depositDate: FciValueTypes.Date,
  depositReference: FciValueTypes.Text,
  lenderAccount: FciValueTypes.Text,
  lenderFullName: FciValueTypes.Text,
  depositAmount: FciValueTypes.Number,
  depositNotes: FciValueTypes.Text,
}
